<app-print-office-header></app-print-office-header>

<ion-content [fullscreen]="true">
  

  <ion-card>
    <ion-card-header>
      <div class="title-row">
        <ion-card-title>{{ printOffice.printOffice?.name?.ge }}</ion-card-title>
        <ion-badge 
          [color]="printOffice.printOffice?.availability == availability.Available ? 'success' : 'danger'" 
          class="clickable-badge status-badge"
          (click)="toggleAvailability(printOffice.printOffice,null,null,null,null)">
        {{ printOffice.printOffice?.availability == availability.Available ? '✔️' : '❌' }}
        </ion-badge>
      </div>
      <ion-card-subtitle>{{ printOffice.printOffice?.address?.ge }}</ion-card-subtitle>
    </ion-card-header>
  
    <ion-card-content>
      <ion-grid>
  
        <!-- Table Header -->
        <ion-row class="table-header">
          <ion-col size="1"><strong>Variation</strong></ion-col>
          <ion-col size="1"><strong>Size</strong></ion-col>
          <ion-col size="1"><strong>Paper Type</strong></ion-col>
          <ion-col size="1"><strong>Extra</strong></ion-col>
          <ion-col size="1"><strong>Black/White Price</strong></ion-col>
          <ion-col size="1"><strong>Coloerde Price</strong></ion-col>
          <ion-col size="1"><strong>Extra Price</strong></ion-col>
          <ion-col size="1"><strong>Available?</strong></ion-col>
        </ion-row>
  
        <ng-container *ngFor="let variation of printOffice.printOffice?.printVariations">
          <ion-row class="variation-divider">
            <ion-col size="12">
              <div class="bold-divider-line"></div>
            </ion-col>
          </ion-row>
          <!-- Variation Row -->
          <ion-row class="variation-row">
            <ion-col size="1"><strong>{{ variation.name.ge }}</strong></ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">—</ion-col>
            <ion-col size="1">
              <ion-badge [color]="variation.availability == availability.Available ? 'success' : 'danger'" 
                         (click)="toggleAvailability(variation,variation.id,null,null,null)"
                         class="clickable-badge">
                {{ variation.availability == availability.Available ? '✔️' : '❌' }}
              </ion-badge>
            </ion-col>
          </ion-row>
  
          <ng-container *ngFor="let size of variation.paperSizes">
  
            <!-- Size Row -->
            <ion-row class="size-row">
              <ion-col size="1">—</ion-col>
              <ion-col size="1"><strong>{{ size.name.ge }}</strong></ion-col>
              <ion-col size="1">—</ion-col>
              <ion-col size="1">—</ion-col>
              <ion-col size="1">—</ion-col>
              <ion-col size="1">—</ion-col>
              <ion-col size="1">—</ion-col>
              <ion-col size="1">
                <ion-badge [color]="size.availability == availability.Available ? 'success' : 'danger'" 
                           (click)="toggleAvailability(size,variation.id,size.id,null,null)"
                           class="clickable-badge">
                  {{ size.availability == availability.Available ? '✔️' : '❌' }}
                </ion-badge>
              </ion-col>
            </ion-row>
  
            <ng-container *ngFor="let paperType of size.paperTypes">
  
              <!-- Paper Type Row -->
              <ion-row>
                <ion-col size="1">—</ion-col>
                <ion-col size="1"><strong>{{ size.name.ge }}</strong></ion-col>
                <ion-col size="1">{{ paperType.name.ge }}</ion-col>
                <ion-col size="1">—</ion-col>
                <ion-col size="1">
                  {{ paperType?.singleSidePrice }}/
                  {{ paperType?.doubleSidePrice }}
                </ion-col>
                <ion-col size="1">
                  {{ paperType?.singleSidePriceColored }}/
                  {{ paperType?.doubleSidePriceColored }}
                </ion-col>
                <ion-col size="1">—</ion-col>
                <ion-col size="1">
                  <ion-badge [color]="paperType.availability == availability.Available ? 'success' : 'danger'" 
                              (click)="toggleAvailability(paperType,variation.id,size.id,paperType.id,null)"
                              class="clickable-badge">
                    {{ paperType.availability == availability.Available ? '✔️' : '❌' }}
                  </ion-badge>
                </ion-col>
              </ion-row>
  
              <!-- Extras Row -->
              <ng-container *ngIf="paperType.paperExtras && paperType.paperExtras.length > 0">
                <ion-row *ngFor="let extra of paperType.paperExtras" class="extras-row">
                  <ion-col size="1">—</ion-col>
                  <ion-col size="1"><strong>{{ size.name.ge }}</strong></ion-col>
                  <ion-col size="1">{{ paperType.name.ge }}</ion-col>
                  <ion-col size="1">{{ extra.name.ge }}</ion-col>
                  <ion-col size="1">—</ion-col>
                  <ion-col size="1">—</ion-col>
                  <ion-col size="1">{{ extra.price }}</ion-col>
                  <ion-col size="1">
                    <ion-badge [color]="extra.availability == availability.Available ? 'success' : 'danger'" 
                                (click)="toggleAvailability(extra,variation.id,size.id,paperType.id,extra.id)"
                                class="clickable-badge">
                      {{ extra.availability == availability.Available ? '✔️' : '❌' }}
                    </ion-badge>
                  </ion-col>
                </ion-row>
              </ng-container>
  
            </ng-container>
          </ng-container>
        </ng-container>
  
      </ion-grid>
    </ion-card-content>
  </ion-card>
  

</ion-content>
